var React = require('react');
var { useState } = require('react');
var { useTranslation } = require('react-i18next');
var { useDispatch } = require('react-redux');
var userActions = require('userActions');
var authenticateActions = require('authenticateActions');
require('./DeleteData.css');

var DELETE_DATA_STATUS = {
  IDLE: 'idle',
  CONFIRMING: 'confirming',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

var GRACE_PERIOD_DAYS = 14;
var AUTO_LOGOUT_DELAY = 5000;

var DELETION_REASONS = [
  'no_longer_need',
  'privacy_concerns',
  'switching_service',
  'too_complex',
  'other',
];

var DeleteData = function () {
  var { t } = useTranslation();
  var dispatch = useDispatch();

  var statusState = useState(DELETE_DATA_STATUS.IDLE);
  var status = statusState[0];
  var setStatus = statusState[1];

  var passwordState = useState('');
  var password = passwordState[0];
  var setPassword = passwordState[1];

  var reasonState = useState('');
  var reason = reasonState[0];
  var setReason = reasonState[1];

  var passwordErrorState = useState('');
  var passwordError = passwordErrorState[0];
  var setPasswordError = passwordErrorState[1];

  var handleDeleteClick = function () {
    setStatus(DELETE_DATA_STATUS.CONFIRMING);
    setPassword('');
    setPasswordError('');
    setReason('');
  };

  var handleCancel = function () {
    setStatus(DELETE_DATA_STATUS.IDLE);
    setPassword('');
    setPasswordError('');
    setReason('');
  };

  var handleConfirm = function () {
    if (!password) {
      setPasswordError(t('delete_data_password_required'));
      return;
    }
    setPasswordError('');
    setStatus(DELETE_DATA_STATUS.LOADING);

    dispatch(userActions.delete_user_data(password, reason))
      .then(function () {
        setStatus(DELETE_DATA_STATUS.SUCCESS);
        setTimeout(function () {
          dispatch(authenticateActions.logout());
        }, AUTO_LOGOUT_DELAY);
      })
      .catch(function () {
        setStatus(DELETE_DATA_STATUS.ERROR);
        setPassword('');
      });
  };

  var handlePasswordChange = function (e) {
    setPassword(e.target.value);
    if (passwordError) {
      setPasswordError('');
    }
  };

  var handleReasonChange = function (e) {
    setReason(e.target.value);
  };

  var handlePasswordKeyDown = function (e) {
    if (e.key === 'Enter' && password) {
      handleConfirm();
    }
  };

  var isLoading = status === DELETE_DATA_STATUS.LOADING;
  var isConfirming = status === DELETE_DATA_STATUS.CONFIRMING || isLoading;

  return (
    <div
      className='container pt-5 pb-5 d-flex justify-content-center'
      style={{ width: 865 }}
    >
      <div
        className='col justify-content-center bg-grey98 pl-4 pr-4 pt-3 pb-3 border-grey91'
        style={{
          borderWidth: 1,
          borderRadius: 10,
          borderStyle: 'solid',
          marginBottom: '32px',
        }}
      >
        <div className='form-row mb-4'>
          <span className='text-grey45 text-size-32 font-weight-bold'>
            {t('delete_my_data')}
          </span>
        </div>

        {status === DELETE_DATA_STATUS.SUCCESS ? (
          <div className='delete-data-success-section mb-4'>
            <div className='delete-data-success-message mb-3'>
              <span className='text-size-16'>
                {t('delete_data_success_grace', { days: GRACE_PERIOD_DAYS })}
              </span>
            </div>
            <div>
              <span className='text-size-14 text-grey45'>
                {t('delete_data_confirmation_email')}
              </span>
            </div>
          </div>
        ) : (
          <div className='mb-4'>
            {/* Warning section */}
            <div className='delete-data-warning mb-3'>
              <span className='text-size-14 text-grey45'>
                {t('delete_data_warning_grace', { days: GRACE_PERIOD_DAYS })}
              </span>
            </div>

            {/* Error message */}
            {status === DELETE_DATA_STATUS.ERROR && (
              <div className='delete-data-error-message mb-3'>
                <span className='text-size-14'>{t('delete_data_error')}</span>
              </div>
            )}

            {/* Confirmation section */}
            {isConfirming ? (
              <div className='delete-data-confirm-section mb-3'>
                <span className='text-size-14 text-grey45 font-weight-semi-bold mb-3 d-block'>
                  {t('delete_data_confirm')}
                </span>

                {/* Optional reason */}
                <div className='mb-3'>
                  <label
                    className='text-size-14 text-grey45 d-block mb-1'
                    htmlFor='delete-reason'
                  >
                    {t('delete_data_reason_label')}
                  </label>
                  <select
                    id='delete-reason'
                    className='form-control form-control-sm'
                    style={{ maxWidth: 320 }}
                    value={reason}
                    onChange={handleReasonChange}
                    disabled={isLoading}
                  >
                    <option value=''>{t('delete_data_reason_select')}</option>
                    {DELETION_REASONS.map(function (key) {
                      return (
                        <option key={key} value={key}>
                          {t('delete_data_reason_' + key)}
                        </option>
                      );
                    })}
                  </select>
                </div>

                {/* Password verification */}
                <div className='mb-3'>
                  <label
                    className='text-size-14 text-grey45 d-block mb-1'
                    htmlFor='delete-password'
                  >
                    {t('delete_data_enter_password')}
                  </label>
                  <input
                    id='delete-password'
                    type='password'
                    className={
                      'form-control form-control-sm' +
                      (passwordError ? ' is-invalid' : '')
                    }
                    style={{ maxWidth: 320 }}
                    value={password}
                    onChange={handlePasswordChange}
                    onKeyDown={handlePasswordKeyDown}
                    disabled={isLoading}
                    autoComplete='current-password'
                  />
                  {passwordError && (
                    <div className='invalid-feedback'>{passwordError}</div>
                  )}
                </div>

                <div className='d-flex'>
                  <button
                    className='btn btn-danger mr-2'
                    onClick={handleConfirm}
                    disabled={isLoading || !password}
                  >
                    {isLoading ? t('loading') : t('delete_data_confirm_button')}
                  </button>
                  <button
                    className='btn btn-secondary'
                    onClick={handleCancel}
                    disabled={isLoading}
                  >
                    {t('cancel')}
                  </button>
                </div>
              </div>
            ) : (
              <button
                className='btn btn-danger'
                onClick={handleDeleteClick}
                disabled={isLoading}
              >
                {t('delete_data_button')}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

module.exports = DeleteData;
